import React, {useEffect} from 'react';
import {emitEventLog} from '@di-shared/features/analytics';
import CapitalContents from '@di-shared/features/capital/CapitalContents';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useFirebaseStore from '@di-shared/features/environment/firebaseStore';
import PublicServiceContents from '@di-shared/features/public-service/PublicServiceContents';
import {isEventDuration} from '@di-shared/pages/[vin]/capital/event1';
import {ROUTE_PATHS} from '@di-shared/routes';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {WebviewUtils} from '@shared/webviewUtils';

export interface CapitalShortHomePageProps {
  vin: string;
}

function CapitalShortHomePage({vin}: CapitalShortHomePageProps): JSX.Element {
  const {t} = useInferableTranslation();
  const {checkCapitalVinWhitelist} = useFirebaseStore(({checkCapitalVinWhitelist}) => ({checkCapitalVinWhitelist}));
  /**
   * [2025-10-28:Jeyoung Lee] FIXME: 이벤트 종료 시 제거 EVENT2
   */
  async function openEventBottomSheet() {
    if (!(checkCapitalVinWhitelist(vin) || isEventDuration())) {
      return;
    }
    const isGoToEvent = await ccWebviewUtils.openBottomSheetWebViewUrl(ROUTE_PATHS.BOTTOM_SHEET_CAPITAL_EVENT_1_INTRO.getFullPath());
    if (isGoToEvent === false) {
      return;
    }
    if (isGoToEvent === 0) {
      emitEventLog({
        event: 'di_driveinfo_interaction',
        data_action: 'bottom_sheet_popup',
        data_name: '자동차 보험 연결하Go 시원한 커피도 Get!_바로가기',
      });
      setTimeout(() => {
        // IOS 에서 바텀시트가 닫히는 근처 시점에 모달이 열려버리면, 그것도 같이 닫아버리는 이슈가 있음
        // 그래서 조금 늦게 열어서 바텀시트가 닫히고 열리게 함
        WebviewUtils.openNewWebView({
          url: window.location.origin + ROUTE_PATHS.CAPITAL_EVENT_1.getFullPath(vin),
          isModal: true,
          isNavigationBar: false,
          isToolBar: false,
        });
      }, 1000);
    } else {
      emitEventLog({
        event: 'di_driveinfo_interaction',
        data_action: 'bottom_sheet_popup',
        data_name: '자동차 보험 연결하Go 시원한 커피도 Get!_오늘 하루 보지 않기',
      });
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      localStorage.setItem('event1BlockedUntil', tomorrow.getTime().toString());
    }
  }

  /**
   * [2025-10-28:Jeyoung Lee] FIXME: 이벤트 종료 시 제거 EVENT2
   */
  useEffect(() => {
    if (!(checkCapitalVinWhitelist(vin) || isEventDuration())) {
      return;
    }
    const blockedUntil = localStorage.getItem('event1BlockedUntil');
    if (blockedUntil && Date.now() < parseInt(blockedUntil, 10)) {
      return;
    }

    if (blockedUntil && Date.now() >= parseInt(blockedUntil, 10)) {
      localStorage.removeItem('event1BlockedUntil');
    }

    openEventBottomSheet();
  }, []);

  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T40155')}</h1>
      </Header>

      <main
        id="case3Finance"
        className="content page_home"
      >
        <CapitalContents
          vin={vin}
          isProduction={true}
        />
        <PublicServiceContents vin={vin} />
      </main>
    </div>
  );
}

export default CapitalShortHomePage;
